module.exports = __webpack_public_path__ + "img/workflow-sending.f3737371.gif";